export const errorMessages = Object.freeze({
    invalidLoadmoreParameters: 'Error! Missing essential parameters: `from` and `to`  for load more, cannot continue'
});
